import { GesCloudApi } from "@ext/enterprise-cloud/GesCloudApi";

// Organization cookies are host-only, so the desktop trades its app session for a code the organization redeems.
const enterGesCloudOrganization = async (appUrl: string, organizationId: string): Promise<string> => {
	const { code, organizationUrl } = await new GesCloudApi(appUrl).createDesktopHandoff(organizationId);
	await new GesCloudApi(organizationUrl).setInitDesktopData(code);
	return organizationUrl;
};

export default enterGesCloudOrganization;
